var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
var Message = styled.p.withConfig({ displayName: "Message", componentId: "sc-13d1kdx" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n\n  margin-bottom: 16px;\n"], ["\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n\n  margin-bottom: 16px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var MessageUnit = function (_a) {
    var message = _a.message;
    return _jsx(Message, { children: message }, void 0);
};
export { MessageUnit };
var templateObject_1;
